import React, {Component} from 'react';
import queryString from '../../helpers/query-string';
import connect from 'react-redux/es/connect/connect';
import { push } from 'connected-react-router';
import { closeAlert, receiveErrorAlert } from '../../actions/commonsActions';
import { withRouter } from 'react-router-dom';
import { updatePasswd, resetPasswd } from '../../actions/authActions';
import {logout} from "../../helpers/authService";
import recoveryValidator from '../../helpers/recoveryValidator';
import {
    FormGroup,
    Form,
    Row,
    Col,
    Input,
    Button,
    Alert
} from 'reactstrap';
import img1 from '../../assets/images/logo-icon.png';
import img2 from '../../assets/images/big/auth-bg.jpg';

const sidebarBackground = {
  backgroundImage: "url(" + img2 + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center"
};

const alertStyle = {
	// position: 'relative',
	// top: '0',
	// right: '0'
	width: '40%'
};

class Recoverpwd extends Component {
	constructor(props) {
		super(props);
		this.state = {
			password_old: '',
			password_new: '',
			isPasswordEqual: '',
			token: null,
			isRecoveryFormVisible: true,
			defaultPassword: false,
			email: ''
		};
    	this.validators = recoveryValidator;
	}

	componentDidMount() {
		const parsedObj = queryString.parse(this.props.location.search);
		if (parsedObj && parsedObj.token) {
			this.setState({
				token: parsedObj.token,
			})
		}
		if (this.props.location.state && this.props.location.state.defaultPassword)
		this.setState({
			defaultPassword: this.props.location.state.defaultPassword,
			email:  this.props.location.state.email
		})
	};

  onInputChange = event => {
		this.setState({
			[event.target.name]: event.target.value,
			isPasswordEqual: ''
		});

    this.formValidators([event.target.name], event.target.value);
    this.formValidators('isPasswordEqual',
	{
		prev: this.state.password_old,
		next: event.target.name === 'password_new' ?
			event.target.value : this.state.password_new
	});
  };

  onSubmit = event => {
    event.preventDefault();
    console.log('submit', this.isFormValid());
    if (this.isFormValid()) {
      console.log('ok');
      const updateObject = {
        token: this.state.token,
        password: this.state.password_new
      };
      this.clearForm();
      if (this.state.defaultPassword) {
          this.props.resetPasswd({
			  email: this.state.email,
			  newPassword: this.state.password_new
		  }).then(res => {
              console.log(res);
              if (res.status === 'OK') {
                  this.setState({
                      isRecoveryFormVisible: false
                  }, () => {
					  logout();
					  setTimeout(() => {
						  this.props.changeLocation('/login');
					  }, 3000);
				  });
              }
              });
	  } else {
          this.props.updatePasswd(updateObject)
              .then(res => {
                  console.log(res);
                  if (res.status === 'OK') {
                      this.setState({
                          isRecoveryFormVisible: false
                      });
                      setTimeout(() => {
                          this.props.changeLocation('/login');
                      }, 4000)
                  }
              });
	  }

    }
  };

  formValidators = (fieldName, value) => {
		this.validators[fieldName].errors = [];
		this.validators[fieldName].state = value;
		this.validators[fieldName].valid = true;
		this.validators[fieldName].rules.forEach(rule => {
			if (rule.test instanceof RegExp) {
				if (!rule.test.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			} else if (typeof rule.test === 'function') {
				if (!rule.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			}
		});
	};

  isFormValid = () => {
		let status = true;
		Object.keys(this.validators).forEach(field => {
			if (!this.validators[field].valid) {
				status = false;
			}
		});
		return status;
	};

  showErrors = fieldName => {
		const validator = this.validators[fieldName];
		const result = '';
		if (validator && !validator.valid) {
			const errors = validator.errors.map((info, index) => {
				return (
					<span className="error" key={index}>
           			 	* {info}
						<br/>
          			</span>
				);
			});

			return <div className="error mb-2">{errors}</div>;
		}
		return result;
	};

  clearForm = () => {
    this.setState({
      password_old: '',
      password_new: '',
      token: null
    })
  };

  render() {
    return <div style={{position: 'relative'}}>
			{/*----------------------- alerts -----------------------------------*/}
			<Alert
				style={alertStyle}
				color={`${this.props.alert.alert.status}`}
				isOpen={this.props.alert.isOpen || false}
			>
				{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
			</Alert>
    	{/*--------------------------------------------------------------------------------*/}
      {/*Recover Password Cards*/}
      {/*--------------------------------------------------------------------------------*/}
      <div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
	      {
          this.state.isRecoveryFormVisible ? (
            <div className="auth-box">
	        <div id="login-block">
            <div className="logo">
                <span className="db"><img src={img1} alt="logo" /></span>
				{
					this.state.defaultPassword ?
						<h5 className="font-medium mb-3">Обновление пароля</h5> :
						<h5 className="font-medium mb-3">Восстановление пароля</h5>
				}
				{
					this.state.defaultPassword ? (
						<p className="text">
							Ваш пароль сброшен. Просьба обновить ваш пароль.
						</p>
					) : ""
				}
            </div>
            <Row>
              <Col xs="12">
                <Form className="mt-3" id="loginform" action="/" onSubmit={this.onSubmit}>
					        {/*<FormGroup>
					          <Input type="email" name="emailid" bsSize="lg" id="uname" placeholder="Email" required />
					        </FormGroup>
                  */}
                  <FormGroup>
                    <Input
                        type="password"
                        placeholder="Enter new Password"
                        name="password_old"
                        id="password_old"
                        required
                        value={this.state.password_old}
                        onChange={this.onInputChange}
                        onFocus={this.props.closeAlert} />
                  </FormGroup>
                  {this.showErrors('password_old')}
                  <FormGroup>
                    <Input
                        type="password"
                        placeholder="Repeat new Password"
                        name="password_new"
                        id="password_new"
                        required
                        value={this.state.password_new}
                        onChange={this.onInputChange}
                        onFocus={this.props.closeAlert} />
                  </FormGroup>
                  {this.showErrors('password_new')}
                  <Row className="mb-4">
                    <Col xs="12">
                    	<Button
                        color="primary"
                        size="lg"
                        type="submit"
                        className={`text-uppercase ${
													this.isFormValid() ? '' : 'disabled'}`}
                        block
                      >
                       Change
                      </Button>
                      {this.showErrors('isPasswordEqual')}
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
	        </div>
	      </div>
          ) : (
            <span></span>
          )
        }

      </div>
    </div>;
  }
}

const mapDispatchToProps = dispatch => {
	return {
		changeLocation: (url) => dispatch(push(url)),
		closeAlert: () => dispatch(closeAlert()),
    	showErrorAlert: msg => dispatch(receiveErrorAlert(msg)),
		updatePasswd: credentials => dispatch(updatePasswd(credentials)),
        resetPasswd: credentials => dispatch(resetPasswd(credentials))
	};
};

const mapStateToProps = state => ({
	alert: state.alert
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Recoverpwd));



// WEBPACK FOOTER //
// ./src/views/authentication/recover-pwd.jsx